import React from "react";
import { Link } from "react-router-dom";
import { HeaderAsociacion } from "../componentes/headerAsociacion";
import { CustomFooter } from "../componentes/footer";
import { FranjaFija } from "../componentes/franjaFija";

export const TerminosCondiciones = () => {
  return (
    <>
      <HeaderAsociacion grande>
        <Link to="/" className="header-asoc-enlace">
          Inicio
        </Link>
      </HeaderAsociacion>

      <FranjaFija izq="#D9D9D9">
      <section className="pagina-legal">
        <h1>Términos y Condiciones de Uso</h1>
        <p><strong>Fase Cuatro S.A.S.</strong></p>
        <p><em>Última actualización: 14 de abril de 2025</em></p>
        <p><em>Jurisdicción: República Argentina</em></p>

        <h2>1. Aceptación de los Términos</h2>
        <p>
          Al acceder o utilizar esta aplicación móvil desarrollada por <strong>Fase Cuatro S.A.S.</strong>,
          aceptás regirte por estos Términos y Condiciones, nuestra Política de Privacidad, y la legislación
          vigente en la República Argentina. Si no estás de acuerdo con alguno de los términos, te pedimos que
          no uses la aplicación.
        </p>

        <h2>2. Funcionalidad de la Aplicación</h2>
        <p>
          La aplicación está diseñada para uso exclusivo de pilotos que participan en competencias registradas
          y organizadas por <strong>Fase Cuatro S.A.S.</strong>. Sus funcionalidades principales incluyen:
        </p>
        <ul>
          <li>Acceso mediante autenticación simple.</li>
          <li>Visualización de resultados personales en carreras.</li>
          <li>Seguimiento de la posición en tablas generales.</li>
          <li>Historial de desempeño en competencias.</li>
        </ul>

        <h2>3. Uso Adecuado</h2>
        <p>Como usuario:</p>
        <ul>
          <li>Te comprometés a utilizar la app de manera lícita y respetando la normativa vigente en Argentina.</li>
          <li>No debés compartir tus credenciales ni intentar manipular los datos mostrados.</li>
          <li>Está prohibido cualquier intento de acceso no autorizado, ingeniería inversa o modificación del funcionamiento de la app.</li>
        </ul>

        <h2>4. Propiedad Intelectual</h2>
        <p>
          Todo el contenido de esta aplicación —incluyendo código, diseños, imágenes, textos y marcas— es propiedad
          de <strong>Fase Cuatro S.A.S.</strong>, protegido por la Ley de Propiedad Intelectual N.º 11.723 y otras normas aplicables.
        </p>

        <h2>5. Limitación de Responsabilidad</h2>
        <p>
          <strong>Fase Cuatro S.A.S.</strong> no garantiza la disponibilidad continua o libre de errores de la app.
          En ningún caso seremos responsables por daños directos o indirectos derivados del uso o la imposibilidad de uso de la aplicación.
        </p>

        <h2>6. Modificaciones</h2>
        <p>
          Nos reservamos el derecho de modificar estos Términos y Condiciones sin previo aviso.
          Las modificaciones entrarán en vigencia una vez publicadas en la app o nuestro sitio web.
        </p>

        <h2>7. Legislación Aplicable y Jurisdicción</h2>
        <p>
          Estos Términos se rigen por las leyes de la República Argentina.
          Para cualquier conflicto que pudiera surgir, el usuario y <strong>Fase Cuatro S.A.S.</strong>
          se someten a la jurisdicción de los tribunales ordinarios de la Ciudad Autónoma de Buenos Aires.
        </p>

        <h2>8. Contacto</h2>
        <p>
          Para consultas o reclamos, podés escribirnos a:<br />
          📧 <a href="mailto:info@fasecuatro.com.ar">contacto@fasecuatro.com.ar</a><br />
          🌐 <a href="https://fasecuatro.com.ar" target="_blank" rel="noopener noreferrer">https://fasecuatro.com.ar</a>
        </p>
      </section>
      </FranjaFija>

      <CustomFooter />
    </>
  );
};
